import React, { useState, useRef } from 'react'
import { useOnClickOutside } from '../../hooks'

import './reset.css'
import './MainLayout.css'

import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'

import Burger from '../../components/Burger/Burger'
import BurgerMenu from '../../components/BurgerMenu/BurgerMenu'

import Hidden from '@material-ui/core/Hidden'

import CookieConsent from 'react-cookie-consent'

const MainLayout = ({ children }) => {
  const [open, setOpen] = useState(false)
  const node = useRef()
  useOnClickOutside(node, () => setOpen(false))
  return (
    <>
      <Hidden smDown>
        <Navbar />
      </Hidden>
      <Hidden mdUp>
        <div ref={node}>
          <Burger open={open} setOpen={setOpen} />
          <BurgerMenu open={open} setOpen={setOpen} />
        </div>
      </Hidden>
      {children}
      <Footer />
      <CookieConsent
        location="bottom"
        buttonText="I Accept"
        style={{ background: '#2B373B' }}
        buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.{' '}
        <span style={{ fontSize: '10px' }}>
          Please accept to continue browsing this page.
        </span>
      </CookieConsent>
    </>
  )
}

export default MainLayout
